import { useApi } from '@/api';
import { ChartSkeleton } from '@/components';
import { useChartTooltip } from '@/hooks';
import {
  Flex,
  formatPercentage,
  textShortener,
  DoughnutChart
} from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export default function VaultsDonutChart({ ilk }: { ilk: string }) {
  const [data, error] = useApi({
    url: `/groups/core/ilks/${ilk}/cdps/share/`
  });
  const navigate = useNavigate();

  if (error) {
    throw error;
  }

  const customTooltip = useChartTooltip(data, 'cdp', 'share', false);

  const chartData = useMemo(() => {
    if (data) {
      return {
        labels: data.map((row) =>
          row.cdp ? String(row.cdp) : textShortener(row.urn)
        ),
        datasets: [
          {
            data: data.map((row) => row.share),
            hoverOffset: 30
          }
        ]
      };
    }
    return null;
  }, [data]);

  const mapping = useMemo(() => {
    if (data) {
      return data.reduce((acc, row) => {
        const key = row.cdp === null ? 'others' : `${row.cdp}`;
        acc[key] = key === 'others' ? 'cdps' : `cdps/${row.urn}`;
        return acc;
      }, {});
    }
    return {};
  }, [data]);

  const customConfig = useMemo(
    () => ({
      options: {
        aspectRatio: 1.8,
        layout: {
          padding: 10
        },
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: customTooltip
          }
        }
      }
    }),
    [customTooltip]
  );

  if (data) {
    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        paddingTop="m"
        width="100%">
        <DoughnutChart
          // @ts-ignore
          config={customConfig}
          data={chartData}
          valueFormatter={formatPercentage}
          url={`/collateral/core/${ilk}`}
          navigate={navigate}
          mapping={mapping}
        />
      </Flex>
    );
  }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      paddingTop="m"
      width="100%">
      <ChartSkeleton type="doughnut" paddingTop="m" />
    </Flex>
  );
}
